import { ActionIcon, Tooltip, type TooltipProps } from '@mantine/core';
import type { TablerIcon } from '@tabler/icons-react';
import { forwardRef, type MouseEventHandler } from 'react';
import { Show } from '../../control-flow/Show';

export const TreeHoverButton = forwardRef<
    HTMLButtonElement | null,
    {
        color?: string;
        Icon: TablerIcon;
        onClick?: MouseEventHandler | undefined;
        tooltip?: { text: string; placement?: TooltipProps['position'] };
    }
>((props, ref) => {
    const iconButton = (
        <ActionIcon
            ref={ref}
            variant={'transparent'}
            c={props.color ?? 'var(--mantine-color-base-button)'}
            size={'small'}
            style={{ padding: 0 }}
            onClick={(event) => {
                event.stopPropagation();
                if (props.onClick) {
                    props.onClick(event);
                }
            }}
        >
            <props.Icon fontSize={'small'} />
        </ActionIcon>
    );

    return (
        <Show
            when={props.tooltip}
            fallback={iconButton}
        >
            {({ text, placement }) => (
                <Tooltip
                    label={text}
                    position={placement ?? 'left'}
                >
                    {iconButton}
                </Tooltip>
            )}
        </Show>
    );
});
